import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';

export interface OfferSummaryItemProps {
  /** Unique within the surrounding accordion. */
  value: string;
  title: string;
  /** Right-hand side, e.g. "2.490 €" or "inklusive". */
  amount: string;
  /** Plain text, line breaks are kept. Without one the row is not expandable. */
  description: string;
}

/** One row of the offer summary – must be rendered inside `AccordionPrimitive.Root`. */
const OfferSummaryItem = ({ value, title, amount, description }: OfferSummaryItemProps) => {
  if (!description.trim()) {
    return (
      <div className="flex items-center justify-between gap-4 py-4 text-sm text-[#082729]">
        <span>{title}</span>
        {/* The spacer keeps the amount aligned with the expandable rows. */}
        <span className="flex shrink-0 items-center gap-2 font-bold">
          {amount}
          <span className="h-4 w-4" />
        </span>
      </div>
    );
  }

  return (
    <AccordionPrimitive.Item value={value}>
      <AccordionPrimitive.Header className="flex">
        <AccordionPrimitive.Trigger className="group flex flex-1 items-center justify-between gap-4 py-4 text-left text-sm text-[#082729]">
          <span>{title}</span>
          <span className="flex shrink-0 items-center gap-2 font-bold">
            {amount}
            <ChevronDown className="h-4 w-4 text-[#082729]/50 transition-transform duration-200 group-data-[state=open]:rotate-180" />
          </span>
        </AccordionPrimitive.Trigger>
      </AccordionPrimitive.Header>
      <AccordionPrimitive.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
        <p className="whitespace-pre-line pb-4 text-sm text-[#082729]/50">{description}</p>
      </AccordionPrimitive.Content>
    </AccordionPrimitive.Item>
  );
};

export default OfferSummaryItem;
